module.exports = __webpack_public_path__ + "images/266e62e50d1b4cc3b7cb1f444465e0ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ru.svg
// module id = 1523
// module chunks = 1